import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  EventEmitter,
  Output,
} from '@angular/core';
import { Chart } from 'chart.js';
import { GraphService } from '../../services/graph.service';

@Component({
  selector: 'egi-graph',
  templateUrl: './egi-graph.component.html',
  styleUrls: ['./egi-graph.component.css'],
})
export class EgiGraphComponent implements OnInit, OnChanges {
  @Input() data: {
    dataFunc?: string;
    funcParams?: any;
    chartConfig?: Chart.ChartConfiguration;
    title?: string;
  } = {
    funcParams: [],
  };

  public canvasId: string;
  public graph: any;
  loaded: boolean = false;

  @Output() emitter: EventEmitter<any> = new EventEmitter<any>();

  constructor(private graphService: GraphService) {}

  ngOnInit(): void {
    this.canvasId =
      'myGraph' + Math.floor(Math.random() * (100000 - 1 + 1)) + 1;
  }
  async ngAfterViewInit() {
    if (this.data.dataFunc && !this.data.chartConfig)
      this.data.chartConfig = await this.graphService.getGraphFromType(
        this.data.dataFunc,
        this.data.funcParams,
      );
    this.emitter.emit('loaded');

    if (this.canvasId) this.createGraph();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data && this.graph) {
      this.graph.data.chartConfig = this.data.chartConfig;
    }
  }

  createGraph() {
    this.graph = new Chart(this.canvasId, this.data.chartConfig);
    this.graph.update();
  }
}

export interface GraphData {
  dataFunc: string;
  funcParams: FuncParams;
}
export interface FuncParams {
  account_num: string;
  start_date: Date;
  end_date: Date;
}
